import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BannersService} from '../../services/banners.service';
import {DomSanitizer} from '@angular/platform-browser';
import {PromosService} from '../../services/promos.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {GoogleAnalyticsService} from 'mugan86-ng-google-analytics';
import {ParamsService} from '../../services/params.service';
import {ShowCardService} from '../../services/ShowCard.service';
import {Banner} from '../../models/banner.model';

@Component({
  selector: 'app-card-banners',
  templateUrl: './card-banners.component.html',
  styleUrls: ['./card-banners.component.css']
})
export class CardBannersComponent implements OnInit {

  banners: Banner[] = [];
  selectedIdCard: number = 0;

  currentPage: number = 1;


  constructor(private bannersService: BannersService,
              private sanitizer: DomSanitizer,
              private promosService: PromosService,
              private router: Router,
              private route: ActivatedRoute,
              private spinner: NgxSpinnerService,
              public googleAnalyticsService: GoogleAnalyticsService,
              private paramsService: ParamsService,
              private showCardService: ShowCardService) {

  }

  ngOnInit() {

    this.selectedIdCard = this.route.snapshot.params['cardId'];
    //console.log('SELECTED CARD_ID(banner): ' + this.selectedIdCard);

    var cardName = this.route.snapshot.params['cardName'];

    if(cardName!=undefined)
      switch (cardName.toLowerCase()) {
        case 'debito':
          this.selectedIdCard=1
          break;
        case 'clasica':
          this.selectedIdCard=2
          break;
        case 'oro':
          this.selectedIdCard=3
          break;
        case 'platinum':
          this.selectedIdCard=4
          break;
        case 'clic':
          this.selectedIdCard=5
          break;
      }


    //----------FOR BANNERS
    this.bannersService.getBanners(this.selectedIdCard)
      .subscribe(
        (banners: Banner[]) => {
          this.banners = banners;
          this.bannersService.setBanners(banners);
        }
      );

  }


  getMobileFormat(bannerName : string){

    return bannerName.replace('promo-name', 'promo-name-mobile');

  }

  getXSMobileFormat(bannerName : string){

    return bannerName.replace('promo-name', 'promo-name-xsmobile');

  }

  getInnerHTML(html: string){

    const regex = /<[^>]+>/g;
    const noTagsText = html.replace(regex, '');

    return noTagsText;
  }

}
